class RevealingTextElement extends HTMLElement {
  constructor() {
    super();
    this._observer = null;
    this._initialized = false;
  }

  connectedCallback() {
    if (
      typeof gsap === 'undefined' ||
      typeof SplitText === 'undefined' ||
      typeof ScrollTrigger === 'undefined'
    ) {
      console.warn('GSAP / SplitText / ScrollTrigger missing');
      return;
    }

    // Reduced motion support
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      gsap.set(this, { visibility: 'visible' });
      return;
    }

    this.observe();
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }

  observe() {
    if (this._initialized) return;

    if ('IntersectionObserver' in window) {
      this._observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.initAnimation();
              this._observer.disconnect();
              this._observer = null;
            }
          });
        },
        {
          rootMargin: '150px 0px', // 🔥 key fix
          threshold: 0,
        }
      );

      this._observer.observe(this);
    } else {
      // Fallback
      this.initAnimation();
    }
  }

  initAnimation() {
    if (this._initialized) return;
    this._initialized = true;

    const hoverColor = this.dataset.hoverColor || '#000';
    const headingColor = this.dataset.textColor || '#000';
    const runMode = this.dataset.run || 'multi';

    const split = SplitText.create(this.children, {
      type: 'words,chars',
      wordsClass: 'word',
      charsClass: 'char',
    });

    gsap.set(this, { visibility: 'visible' });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this,
        start: 'top 75%',
        end: 'bottom 25%',
        toggleActions:
          runMode === 'once'
            ? 'play none none none'
            : 'play reverse play reverse',
      },
    });

    tl.to(split.chars, {
      color: hoverColor,
      duration: 0.5,
      stagger: { amount: 0.8 },
    }).to(
      split.chars,
      {
        color: headingColor,
        duration: 0.5,
        stagger: { amount: 0.8 },
      },
      0.4
    );

    // 🔥 CRITICAL for Shopify
    ScrollTrigger.refresh();
  }
}

customElements.define('revealing-text-element', RevealingTextElement);
